'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedNumber from './FormattedNumber';
import NumberTypes from '../constants/NumberTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedPercentage extends Component {
  render() {
    return /*#__PURE__*/_jsx(FormattedNumber, Object.assign({
      style: NumberTypes.PERCENTAGE
    }, this.props));
  }
}
FormattedPercentage.displayName = 'FormattedPercentage';
FormattedPercentage.propTypes = {
  precision: PropTypes.number,
  stripInsignificantZeros: PropTypes.bool,
  value: PropTypes.number.isRequired
};